/**
 * House関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _RoomState = {
  id: null,
  name: '',
  address: '',
  map_url: '',
  key_code: '',
  room_group_code: '',
  default_check_in: '',
  default_check_out: '',

  // 画像関連
  image: null,
  image_url: '',
  image_name: '',
  information: null,
  information_url: '',
  information_name: '',
  logo: null,
  logo_url: '',
  logo_name: '',
  menu_image: null,
  menu_image_url: '',
  menu_image_name: '',
  top_logo: null,
  top_logo_url: '',
  top_logo_name: '',

  remove_logo_url: null,
  remove_top_logo_url: null,
  remove_image_url: null,
  remove_information_url: null,
  remove_menu_image_url: null,

  // Beds24
  beds24_api_key: '',
  beds24_prop_key: '',
  beds24_roomid: '',
  // ねっぱん
  neppan_base_url: '',
  neppan_userid: '',
  neppan_password: '',
  neppan_room_type_code: '',

  alert_email: null,
  system_error_email: null
}

const UPLOAD_URLS = ['logo_url', 'top_logo_url', 'image_url', 'menu_image_url', 'information_url']

class RoomState extends Record(_RoomState) {
  getFileName(url) {
    return url ? url.replace(/.*\/|[^.]*\/$/g, '') : ''
  }

  mergeRoom(model) {
    const updateKeys = UPLOAD_URLS.filter(filename => Object.keys(model).reduce((acc, cur) => (acc ? true : cur === filename && model[cur]), false))

    updateKeys.forEach(key => {
      model[key.replace('_url', '_name')] = this.getFileName(model[key])
    })

    return this.merge(model)
  }

  applyChannelManager(channelManager) {
    if (channelManager === 'beds24') {
      return this.merge({
        neppan_base_url: null,
        neppan_userid: null,
        neppan_password: null,
        neppan_room_type: null
      })
    }

    if (channelManager === 'neppan') {
      return this.merge({
        beds24_api_key: null,
        beds24_prop_key: null,
        beds24_roomid: null
      })
    }

    return this.merge({
      neppan_base_url: null,
      neppan_userid: null,
      neppan_password: null,
      neppan_room_type: null,
      beds24_api_key: null,
      beds24_prop_key: null,
      beds24_roomid: null
    })
  }

  setRoom(key, value) {
    if (UPLOAD_URLS.some(filename => filename === key)) {
      return this.set(key.replace('_url', '_name'), this.getFileName(value)).set(key, value)
    }
    return this.set(key, value)
  }
}

export { RoomState, UPLOAD_URLS }
